export default "__VITE_ASSET__Cdh25aSg__"